import React from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Error from './components/Error';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import './App.css';
import logoImage from "./images/logo.png";

function Home() {
  return (
    <div className="App">
     
	  <header className="App-header">
	  
        <h1>World </h1>
		<img src={logoImage} alt="Example" style={{width:'100px',height:'100px'}} class="vibrating-image" /> 
		 <h1> Radio</h1>
      </header>
	  <main className="App-main">
	  
	  <DotLottieReact src="https://lottie.host/cf3594ce-17d1-43ee-a174-5a1ddd54d55b/Czhn4hM2Sn.lottie"
      loop style={{width:'500px',height:'300px'}}
      autoplay/>
	  
	  </main>
      <footer className="App-footer">
	    <Link to="/">Home</Link>   | 
        <Link to="/terms">Terms and Conditions</Link>   | 
        <Link to="/privacy">Privacy Policy</Link>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
}

export default App;

